export const extractGraphqlArrayPayload = (data, fieldName) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return null;
  }

  const payload = data[fieldName];
  return Array.isArray(payload) ? payload : null;
};

export const normalizeNullishArrayPayload = payload =>
  payload == null ? null : payload;
